<div *ngIf="isShown" id="ot-sdk-cookie-policy"></div>